// src/components/layout/Layout.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './NavBar';
import Footer from './Footer';

/*
function Layout({ children }) {
  return (
    <div className="app-layout">
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
*/

const Layout = ({ user, onSignIn, onSignOut }) => {
  return (
    <div style={{ 
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column'
    }}>
      <Navbar isAuthenticated={!!user} />
      
      {/* Auth button - temporarily removed
      <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
        {user ? (
          <button onClick={onSignOut}>Sign out</button>
        ) : (
          <button onClick={onSignIn}>Sign in</button>
        )}
      </div>
      */}

      {/* User info display - temporarily removed
      {user && (
        <div style={{ margin: '1rem', fontSize: '0.8rem', color: '#666' }}>
          Logged in as: {user.signInDetails?.loginId || user.username}
        </div>
      )}
      */}

      {/* Main content area */}
      <main style={{ 
        padding: '1rem',
        flex: '1 0 auto'
      }}>
        <Outlet />
      </main>
      
      <Footer />
    </div>
  );
};

export default Layout;